import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
	CompletionList, FileUploader,
	DashboardUserDetails
} from '../'

import * as Actions from 'actions';

class DashBoardProfile extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dashboard_up_to_date : true
		}

		this.handleUpdateProfile = this.handleUpdateProfile.bind(this);
	}

	handleUpdateProfile() {
  	this.props.showEditUser(this.props.user)
  }

	render() {
		let user = this.props.user;

		var dashboard_image_classname;
  	var dashboard_image_container_classname;

  	if(user.profile_picture) {
  		dashboard_image_classname =
  			'rounded img-responsive dashboard-profile-image'
			dashboard_image_container_classname =
				'thumb-info mb-md dashbard-profile-pic-container dashboard-profile-pic-container';
  	}
  	else if(user.avatar) {
  		dashboard_image_classname =
  			'rounded img-responsive dashboard-profile-avatar';
  		dashboard_image_container_classname =
  			'thumb-info mb-md dashbard-profile-avatar-container dashboard-profile-pic-container';
  	}
  	else {
  		dashboard_image_classname =
  			'rounded img-responsive dashboard-profile-no-pic'
  		dashboard_image_container_classname =
  			'thumb-info mb-md dashboard-profile-pic-container dashboard-profile-no-pic-container';
  	}

		let prof_pic = {
			name : 'Profile Picture',
			data : user.profile_picture != null
		}
		let avatar = {
			name : 'Avatar',
			data : user.avatar != null
		}
		let address = {
			name : 'Address',
			data : !(Object.keys(user.address).length < 5)
		}
		let phone = {
			name : 'Phone Number',
			data : !(!user.personal_phone)
		}
		let company = {
			name : 'Company',
			data : !(!user.company_name)
		}

		let list = [prof_pic, avatar, address, phone, company];

		return (
			<div className='dashboard-profile-container ml-sm mr-sm'>
      	<div className='animated fadeIn'>
          <div className={dashboard_image_container_classname}>
            <img
            	src={
            		(user.profile_picture || {}).url ||
            		user.avatar ||
            		'assets/images/!logged-user.jpg'
            	}
            	className={dashboard_image_classname}
            />
            <div className='thumb-info-title'>
              <span className='thumb-info-inner'>{user.name.first} {user.name.last}</span>
              <span className='thumb-info-type'>{user.role}</span>
            </div>
          </div>
        </div>
        {(() => {
        	if(list.find(e => e.data == false) != undefined)
        		return (
        			<div className="mb-sm">
          			<hr className='short' />
			          <CompletionList
			          	user={user}
			          	list={list}
			          />
		          </div>
        		)
        })()}
				<div
					className='btn btn-sm btn-block btn-default'
					onClick={this.handleUpdateProfile}>
						<i className="fa fa-edit"></i> Update Profile
				</div>
        <hr className='short' />
        <DashboardUserDetails
        	user={this.props.user}
        />
	    </div>
		)
	}
}

export default connect(null, Actions)(DashBoardProfile);



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboardProfile.js